import type { SelectHTMLAttributes, ReactNode } from 'react';
import './Select.css';

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  /** Visual error state (red border). Use alongside FormField's `error` prop. */
  error?: boolean;
  children: ReactNode;
}

/**
 * Token-driven `<select>` for forms. Native dropdown — keeps screen-reader
 * support and OS-native UX without reinventing a custom widget. Pairs with
 * `FormField` for label/required/error.
 */
export function Select({ error, className = '', children, ...props }: SelectProps) {
  return (
    <select
      className={`ui-select ${error ? 'ui-select--error' : ''} ${className}`.trim()}
      {...props}
    >
      {children}
    </select>
  );
}
